import contentDa from './da.json';
import contentEn from './en.json';

export default (language) => {
  let content;
  switch (language) {
    case 'da':
      content = contentDa;
      break;
    default:
      content = contentEn;
      break;
  }
  return content;
};
